<alaris-dialog
	[closeAction]="close.bind(this)"
	[closeButtonText]="'gl.stayOnPage'"
	[confirmAction]="confirm.bind(this)"
	[confirmButtonText]="'gl.leaveWithoutSaving'"
>
	<ng-container slot="header">
		<div class="header">
			<alaris-icon class="icon" name="icon-warning-circle"></alaris-icon>
			<h3>{{ 'gl.leaveWithoutSaving' | translate }}?</h3>
		</div>
	</ng-container>
	<ng-container slot="content">
		{{ 'gl.changesBeLost' | translate }}
	</ng-container>
</alaris-dialog>
